import * as React from "react";
const SvgCheckIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", style: {
  fill: "rgba(0, 0, 0, 1)",
  transform: "",
  msfilter: ""
}, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z" }));
export default SvgCheckIcon;
